<div class="appointment-weekly-calendar">
  <!-- Stats Section - Outside of card for better layout -->
  <div class="mb-4" *ngIf="!isSuperAdmin()">
    <app-dashboard-stats></app-dashboard-stats>
  </div>
  <div class="flex flex-col gap-4">
    <div class="flex flex-col md:flex-row gap-3">
      <app-company-picker-compact *ngIf="isSuperAdmin()"></app-company-picker-compact>
      <app-caregiver-picker-compact (valueChange)="onCaregiverChange($event)"></app-caregiver-picker-compact>
      <app-patient-picker-compact (valueChange)="onPatientChange($event)"> </app-patient-picker-compact>
      <p-datePicker
        [(ngModel)]="currentDate"
        (onSelect)="onDateSelect($event)"
        placeholder="Select a Date"
        inputId="calendar-date"
        showIcon="true"
        [showButtonBar]="true"
        [touchUI]="false"
        size="small"
        [dateFormat]="'mm/dd/yy'"
      ></p-datePicker>
    </div>

    <p-card class="calendar-panel p-1">
      <div class="relative min-h-[600px]">
        <div class="calendar-container">
          <full-calendar [options]="calendarOptions" (eventClick)="onEventClick($event)" #calendar></full-calendar>
          <div
            *ngIf="isLoading"
            class="absolute inset-0 bg-white dark:bg-surface-900 bg-opacity-75 dark:bg-opacity-75 flex items-center justify-center z-50"
          >
            <p-progressSpinner styleClass="w-8 h-8" strokeWidth="4"></p-progressSpinner>
          </div>
        </div>

        <!-- Empty State with PrimeNG Message -->
        <div *ngIf="!isLoading && noEvents" class="flex items-center justify-center p-8">
          <p-message severity="info" [closable]="false" styleClass="w-full max-w-md">
            <ng-template pTemplate="content">
              <div class="text-center">
                <i class="pi pi-calendar text-4xl text-primary mb-3"></i>
                <div class="font-medium">{{ 'appointments' | dynamicText | async }} not found</div>
                <div class="text-sm mt-2">Try adjusting your filters or selecting a different date range.</div>
              </div>
            </ng-template>
          </p-message>
        </div>
      </div>
    </p-card>
  </div>
</div>

<app-edit-check-in-out-modal
  [displayModal]="displayEditModal"
  [currentVisitDetails]="selectedVisitDetails"
  (modalClosed)="handleModalClose()"
  (saved)="handleModalSave()"
></app-edit-check-in-out-modal>
